import { List, ListItem } from "@mui/material";
import { useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import CustomerSupportDialog from "../../app/landingPages/customerSupport";
import { landingPageRoutes } from "../../routes";
import { customerSupport } from "../../services/Suport";
import Loader from "../Loader";
import SnackbarAlert from "../SnackBar";

const Navlinks = () => {
  const dialogRef = useRef(null);
  const { pathname } = useLocation();
  const [isLoading, setIsLoading] = useState(false);

  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    resetForm();
  };

  const resetForm = () => {
    setForm({
      name: "",
      email: "",
      phone: "",
      message: "",
    });
  };

  const handleChange = (key, value) => {
    setForm((prev) => ({ ...prev, [key]: value }));
  };
  const handleSnackbarVal = (open, type, message) => {
    setSnackbarProps({
      open,
      type,
      message,
    });
  };
  const [snackbarProps, setSnackbarProps] = useState({
    open: false,
    type: "",
    message: "",
  });

  const handleSubmit = async (e) => {
    try {
      if (e) e.preventDefault();

      const { name, email, phone, message } = form;
      if (!name || !email || !phone || !message) {
        handleSnackbarVal(true, "error", "All fields are required.");
        return;
      }
      setIsLoading(true);
      const responce = await customerSupport({
        name,
        email,
        phone,
        message,
      });
      setIsLoading(false);

      if (responce?.status === 200 || responce?.status === 201) {
        handleSnackbarVal(true, "success", responce?.data?.message);
      } else {
        handleSnackbarVal(true, "error", responce?.data?.message);
      }

      handleClose();
    } catch (error) {
      console.log(error, "errorerrorerrorerror124656");

      setIsLoading(true);
    }
  };

  const handleCustomerSupportClick = () => {
    handleOpen();
  };

  const style = {
    listItem: {
      position: "relative",
      px: 0,
      "&::after": {
        content: '""',
        position: "absolute",
        bottom: 0,
        left: 0,
        height: "2px",
        backgroundColor: "#ffffff",
        transition: "width 0.3s ease-in-out",
        width: "0%",
      },
      "&:hover::after": {
        width: "100%",
      },
    },
    link: {
      color: "#ffffff",
      textDecoration: "none",
      fontSize: "1rem",
      cursor: "pointer",
    },
  };
  const handleCloseSnackbar = () => {
    handleSnackbarVal(false, "", "");
  };
  return (
    <>
      <List
        sx={{
          display: { xs: "none", sm: "flex" },
          alignItems: "center",
          whiteSpace: "nowrap",
          gap: 3,
        }}
      >
        {landingPageRoutes.map((val, ind) =>
          val.name !== "Login" ? (
            <ListItem
              key={ind}
              sx={{
                ...style.listItem,
                "&::after": {
                  ...style.listItem["&::after"],
                  width: pathname === val.path ? "100%" : "0",
                },
              }}
            >
              <Link style={style.link} to={val.path}>
                {val.name}
              </Link>
            </ListItem>
          ) : null
        )}
        <ListItem sx={style.listItem}>
          <span style={style.link} onClick={handleCustomerSupportClick}>
            Customer Support
          </span>
        </ListItem>
      </List>

      <CustomerSupportDialog
        ref={dialogRef}
        open={open}
        onClose={handleClose}
        form={form}
        onChange={handleChange}
        onSubmit={handleSubmit}
      />
      <SnackbarAlert
        handleCloseSnackbar={handleCloseSnackbar}
        snackbarProps={snackbarProps}
      />
      <Loader isLoading={isLoading} />
    </>
  );
};

export default Navlinks;
